import { Alert, Page } from '@ui/themed';
import { t } from 'i18next';
import { useUser, withPageProviders } from '../../../../context/page-context';
import { TwoFactorStatusCard } from '../../two-factor/components/two-factor-status-card';
import { SettingsPasswordForm } from '../components/settings-password-form';

export const SettingsPasswordPage = withPageProviders(SettingsPasswordPageContent);

function SettingsPasswordPageContent() {
  const { manageAccount, isSparkStaff } = useUser();

  return (
    <Page>
      {manageAccount ? (
        <>
          <SettingsPasswordForm />
          {isSparkStaff && <TwoFactorStatusCard />}
        </>
      ) : (
        <Alert headingLevel="h2" variant="warning">
          {t('features:account.pages.settings_password_page.warning')}
        </Alert>
      )}
    </Page>
  );
}
